export default function videoLazyload() {
    const lazyVideos = document.querySelectorAll('video[data-src]');

    if ('IntersectionObserver' in window) {
        const videoObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const video = entry.target;
                    const source = video.getAttribute('data-src');
                    
                    if (source) {
                        video.src = source;
                        video.load();
                    }
                    
                    video.classList.remove('lazy');
                    videoObserver.unobserve(video);
                }
            });
        });

        lazyVideos.forEach((video) => {
            videoObserver.observe(video);
        });
    } else {
        // Fallback for browsers without IntersectionObserver
        lazyVideos.forEach((video) => {
            const source = video.getAttribute('data-src');
            if (source) {
                video.src = source;
                video.load();
            }
            video.classList.remove('lazy');
        });
    }
}
